import styled from "styled-components";
import {Form} from "react-bootstrap";


export const ModalAccessContainer = styled.div`
display: flex;
  flex-direction: column;
  gap: 10px;
`

export const ModalAccessLink = styled.div`
display: grid;
  grid-template-columns: 1fr 10px;
  gap: 10px;
  align-items: center;
`

type ModalAccessFormCheckProps = {
    color?: string | undefined;
}
export const ModalAccessFormCheck = styled(Form.Check)<ModalAccessFormCheckProps>`
    color: ${({color}) => color};

`
